import WalletSignIn from './WalletSignIn.container'

export default WalletSignIn
